<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card no-body class="p-4">
            <b-card-body>
              <b-form @submit.prevent="resetPassword">
                <h1>Reset Password</h1>
                <p class="text-muted">Please provide your preferred new password.</p>

                <form-password
                  v-model="form.password"
                  name="password"
                  :labelless="true"
                  autocomplete="off"
                  placeholder="New Password"
                />
                <form-password
                  v-model="form.password_confirmation"
                  name="password-confirmation"
                  :labelless="true"
                  autocomplete="off"
                  placeholder="Password Confirmation"
                />

                <b-button type="submit" variant="primary" class="px-4"> Reset Password </b-button>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: new window.AppForm({
        email: "",
        token: "",
        password: "",
        password_confirmation: "",
      }),
    };
  },

  created() {},

  methods: {
    resetPassword() {
      this.form.email = this.$route.query.email;
      this.form.token = this.$route.query.token;

      this.form
        .post("/password/reset")
        .then((response) => {
          if (response && response.success) {
            window.toastr.success("Password has been updated!", "Success");
            this.$router.push({
              name: "login",
            });
          } else {
            window.toastr.warning(
              "An error occurred when trying to update the password!",
              "Warning"
            );
          }
        })
        .catch(() => {
          window.toastr.warning("An error occurred when trying to update the password!", "Warning");
        });
    },
  },
};
</script>
